<template>
  <div>
    <section class="client-listing-area">
      <div class="client-listing-head-fluid" style="padding-bottom: 5px;">
        <div class="container">
          <div class="client-listing-head">
            <PendingReviewSearchBar />
          </div>
          <!-- ends client-listing-head -->
        </div>
      </div>
      <!-- ends client-listing-head-fluid -->
      <div class="client-listing-detail-fluid">
        <div class="container px-0">
          <div class="client-listing-detail">
            <PendingReviewList/>
          </div>
          <!-- ends client-listing-detail -->
        </div>
      </div>
      <!-- ends client-listing-detail-fluid -->
    </section>
  </div>
</template>

<script>
import PendingReviewList from '@/components/dashboard/applicants/PendingReviewList.vue';
import PendingReviewSearchBar from '@/components/dashboard/applicants/PendingReviewSearchBar.vue';
import { mapMutations } from 'vuex';

export default {
  name: 'PendingReview',
  components: { PendingReviewSearchBar, PendingReviewList },
  mounted() {
    this.changeBodyBackground();
    // Set status filter to only show '確認依頼中' applicants
    this.setStatusModel(['確認依頼中']);
  },
  methods: {
    ...mapMutations({
      setStatusModel: 'setStatusModel',
    }),
  },
  beforeRouteLeave(to, from, next) {
    // Clear status filter when leaving
    this.setStatusModel([]);
    next();
  },
};
</script> 